/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coveradjustframe2Inputs */

const en_coveradjustframe2 = /** @type {(inputs: Coveradjustframe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move the visible section`)
};

const de_coveradjustframe2 = /** @type {(inputs: Coveradjustframe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildausschnitt verschieben`)
};

/**
* | output |
* | --- |
* | "Move the visible section" |
*
* @param {Coveradjustframe2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coveradjustframe2 = /** @type {((inputs?: Coveradjustframe2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coveradjustframe2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coveradjustframe2(inputs)
	return de_coveradjustframe2(inputs)
});
export { coveradjustframe2 as "coverAdjustFrame" }